import { BoothPattern } from 'models';

const BoothHelpers = {
    getHall: (
        booth: string,
        boothPatterns?: BoothPattern[] | null,
        eventName?: string,
    ): { hallName: string; hallId: string } => {
        if (!boothPatterns || boothPatterns.length === 0) {
            return { hallName: eventName || '', hallId: '' };
        }

        for (const pattern of boothPatterns) {
            try {
                const regex = new RegExp(pattern.pattern);

                if (regex.test(booth)) {
                    const hallName = pattern.hallName || eventName || '';
                    return { hallName, hallId: pattern.hallId };
                }
            } catch (error) {
                console.warn(`Invalid regex pattern: ${pattern.pattern}`, error);
                continue;
            }
        }

        return { hallName: eventName || '', hallId: '' };
    },

    getMapUrl: (booth: string, baseUrl?: string, boothPatterns?: BoothPattern[], eventName?: string): string => {
        const mapBaseUrl = baseUrl;

        if (!mapBaseUrl) {
            return '';
        }

        const hallInfo = BoothHelpers.getHall(booth, boothPatterns, eventName);

        if (!hallInfo?.hallId) {
            return '';
        }

        return `${mapBaseUrl}?hallID=${hallInfo.hallId}&selectedBooth=${booth}`;
    },

    getHallPrefixes: (boothPatterns?: BoothPattern[] | null): { prefix: string; hallName: string }[] => {
        return (boothPatterns ?? []).flatMap((boothPattern) => {
            const prefix = boothPattern.pattern.match(/^\^([A-Z]+)\\d/)?.[1];

            return prefix && boothPattern.hallName ? [{ prefix, hallName: boothPattern.hallName }] : [];
        });
    },
};

export { BoothHelpers };
